import LegalPage from '../components/LegalPage';

const warn = (content) => (
  <div style={{ padding: '14px 16px', background: 'rgba(255,215,0,0.04)', border: '1px solid rgba(255,215,0,0.1)', borderRadius: '6px', marginBottom: '12px' }}>
    <p style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '12px', color: '#FFD700', marginBottom: '6px', fontWeight: 600 }}>IMPORTANT</p>
    {content}
  </div>
);

const bullet = (items) => (
  <ul style={{ listStyleType: 'none', padding: 0 }} className="space-y-2">
    {items.map((item, i) => (
      <li key={i} style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
        <span style={{ color: '#FFD700', flexShrink: 0, marginTop: '6px' }}>&#9472;</span>
        <span>{item}</span>
      </li>
    ))}
  </ul>
);

const sections = [
  {
    title: 'Not Financial Advice',
    content: (
      <div className="space-y-3">
        {warn(<p style={{ fontSize: '14px', color: '#ccc' }}>The information provided on neuro-mesh.io, in our whitepaper, and through our Services does not constitute financial, investment, legal, or tax advice.</p>)}
        <p>Nothing on this website should be construed as a recommendation to buy, sell, hold, or avoid any cryptocurrency, token, or financial instrument.</p>
        <p>You should consult with qualified financial, legal, and tax professionals before making any investment decisions.</p>
      </div>
    ),
  },
  {
    title: 'Tokens Are Not Securities',
    content: (
      <div className="space-y-4">
        <p>The tokens described on this website (including but not limited to $NEURO, cCOMP, nDATA-R, nROBOT, nENERGY, nSTOR, and iCTVs) are <strong style={{ color: '#fff' }}>utility tokens</strong> intended for use within the NeuroMesh protocol.</p>
        <div>
          <p style={{ marginBottom: '8px', color: '#ccc' }}>These tokens are NOT:</p>
          {bullet(['Securities', 'Shares in Thalamus Labs Ltd', 'Investment contracts', 'Notes, bonds, or debt instruments', 'Profit-sharing agreements'])}
        </div>
        <div>
          <p style={{ marginBottom: '8px', color: '#ccc' }}>Token purchasers should understand that:</p>
          {bullet(['Token value may go to zero', 'There is no guarantee of liquidity', 'Token utility depends on protocol adoption', 'Regulatory classification is uncertain and may change'])}
        </div>
      </div>
    ),
  },
  {
    title: 'Forward-Looking Statements',
    content: (
      <div className="space-y-4">
        <p>Our website, whitepaper, and documentation contain forward-looking statements regarding:</p>
        {bullet(['Projected adoption rates', 'Revenue projections', 'Token economics and valuations', 'Technology development timelines', 'Partnership negotiations', 'Market size estimates'])}
        <p style={{ color: '#666', fontSize: '13px', fontStyle: 'italic' }}>These statements are estimates and predictions. Actual results may differ materially. We undertake no obligation to update forward-looking statements.</p>
      </div>
    ),
  },
  {
    title: 'No Guarantees of Performance',
    content: (
      <div className="space-y-3">
        <p>We do not guarantee:</p>
        {bullet([
          'That the NeuroMesh protocol will function as described',
          'That smart contracts are free of vulnerabilities',
          'Specific uptime or performance levels',
          'Token liquidity or exchange listings',
          'Achievement of any roadmap milestones',
        ])}
        <p style={{ color: '#666', fontSize: '13px', marginTop: '12px' }}>The protocol is in development. Features may be delayed, modified, or abandoned.</p>
      </div>
    ),
  },
  {
    title: 'Smart Contract Risk',
    content: (
      <div className="space-y-3">
        <p>Use of the NeuroMesh protocol involves interacting with smart contracts deployed on public blockchains. This carries significant risk, including but not limited to:</p>
        {bullet([
          'Smart contract bugs or vulnerabilities',
          'Exploitation of protocol mechanics',
          'Loss of funds due to user error',
          'Blockchain network congestion or failure',
          'Oracle failures or data inaccuracies',
        ])}
        <p style={{ color: '#ff6b6b', fontSize: '13px', fontFamily: "'JetBrains Mono', monospace", marginTop: '12px' }}>You should only interact with our protocol if you understand these risks fully.</p>
      </div>
    ),
  },
  {
    title: 'Regulatory Uncertainty',
    content: (
      <div className="space-y-3">
        <p>Cryptocurrency, token, and blockchain regulations are evolving globally. You are solely responsible for:</p>
        {bullet([
          'Complying with laws applicable to you',
          'Determining whether token purchases are legal in your jurisdiction',
          'Obtaining necessary licenses or approvals',
          'Paying applicable taxes',
        ])}
        <p>We reserve the right to restrict or block access from certain jurisdictions.</p>
      </div>
    ),
  },
  {
    title: 'Technical Risk',
    content: (
      <div className="space-y-4">
        <p>Our technology involves emerging AI and robotics systems, novel cryptographic primitives, and complex distributed systems. No warranty is made regarding:</p>
        {bullet([
          'Security of the protocol or smart contracts',
          'Accuracy of AI/ML outputs',
          'Safety of robots running NeuroMesh software',
          'Compatibility with third-party hardware or software',
        ])}
      </div>
    ),
  },
  {
    title: 'Limitation of Liability',
    content: (
      <div style={{ padding: '16px', background: 'rgba(255,60,60,0.04)', border: '1px solid rgba(255,60,60,0.1)', borderRadius: '6px' }}>
        <p style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '12px', color: '#ff6b6b', marginBottom: '12px', fontWeight: 600 }}>TO THE MAXIMUM EXTENT PERMITTED BY LAW</p>
        <p>Thalamus Labs Ltd and its affiliates shall not be liable for any losses or damages arising from token purchases or trading, use or inability to use the protocol, smart contract interactions, reliance on any information provided, or any other matter related to our Services.</p>
      </div>
    ),
  },
  {
    title: 'Educational Purpose',
    content: <p>The technical documentation, whitepaper, and explanations on our website are for educational and informational purposes only. They describe our intended protocol design but may not reflect actual implementation.</p>,
  },
  {
    title: 'Assumption of Risk',
    content: (
      <div className="space-y-3">
        <p>By using this website and our Services, you acknowledge that:</p>
        {bullet([
          'Cryptocurrency and token investments are highly speculative',
          'You may lose your entire investment',
          'You have the technical sophistication to understand the risks',
          'You are not relying on any representation not contained in these disclaimers',
          'You have had the opportunity to seek independent financial and legal advice',
        ])}
      </div>
    ),
  },
  {
    title: 'Contact',
    content: (
      <p style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: '13px' }}>
        For questions about these disclaimers: <a href="mailto:legal@neuro-mesh.io" style={{ color: '#00F0FF' }}>legal@neuro-mesh.io</a>
      </p>
    ),
  },
];

export default function Disclaimer() {
  return <LegalPage title="Important Disclaimers" lastUpdated="February 2026" sections={sections} />;
}
